import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
const ImageRow = () => {
    const { user } = useSelector((state) => ({ ...state }));
    const [uploadedImagesBanner, setUploadedImagesBanner] = useState([]);
    const [selectedImagesBanner, setSelectedImagesBanner] = useState([]);

    useEffect(() => {
        const fetchUploadedImages = async () => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_API + "/admin/images/all?type=banner",
                    { headers: { authtoken: user.token } }
                );

                const allImages = response.data;

                // แสดงทั้งหมดใน Uploaded Images
                setUploadedImagesBanner(allImages);

                // กรองเฉพาะที่เลือกไว้ใน Preview (Demo)
                setSelectedImagesBanner(allImages.filter((image) => image.isSelected));
            } catch (error) {
                console.error("Error fetching uploaded images:", error);
            }
        };

        fetchUploadedImages();
    }, [user.token]);

    const handleSelectBannerImage = (image) => {
        const updatedImages = uploadedImagesBanner.map((img) =>
            img._id === image._id ? { ...img, isSelected: !img.isSelected } : img
        );

        setUploadedImagesBanner(updatedImages);

        const selected = updatedImages.filter((img) => img.isSelected);
        setSelectedImagesBanner(selected);
    };
    const handleDeleteImage = async (id) => {
        try {
            // เรียก API เพื่อลบรูปภาพ
            await axios.delete(process.env.REACT_APP_API + `/admin/deleteimage-carousel/${id}`, {
                headers: {
                    authtoken: user.token, // ส่ง token สำหรับการตรวจสอบสิทธิ์
                },
            });

            // อัปเดตรายการรูปภาพใน state หลังจากลบสำเร็จ
            setUploadedImagesBanner(uploadedImagesBanner.filter((image) => image._id !== id));
            setSelectedImagesBanner(selectedImagesBanner.filter((image) => image._id !== id));

            alert("ลบรูปภาพสำเร็จ!");
        } catch (error) {
            console.error("Error deleting image:", error);
            alert("การลบรูปภาพล้มเหลว");
        }
    };
    
    const handleSaveSelectedBannerImages = async () => {
        try {
            const selectedImageIds = uploadedImagesBanner.map((image) => ({
                _id: image._id,
                isSelected: image.isSelected, order: image.order,
            }));

            await axios.post(
                process.env.REACT_APP_API + "/admin/save-selected-images",
                { selectedImages: selectedImageIds },
                {
                    headers: {
                        authtoken: user.token,
                    },
                }
            );

            alert("บันทึกรายการ Banner ที่เลือกสำเร็จ!");
        } catch (error) {
            console.error("Error saving selected Banner images:", error);
            alert("บันทึกล้มเหลว");
        }
    };
    return (
        <>
            <div className="mt-5">
                <h3>Uploaded Banner Images</h3>
                <div className="row">
                    {uploadedImagesBanner.map((image) => (
                        <div className="col-md-4 mb-3" key={image._id}>
                            <div className="card">
                                <img
                                    src={image.url}
                                    alt={image.alt}
                                    className="card-img-top"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleSelectBannerImage(image)}
                                />
                                <div className="card-body text-center">
                                    <button
                                        className={`btn ${image.isSelected ? "btn-success" : "btn-outline-primary"}`}
                                        onClick={() => handleSelectBannerImage(image)}
                                    >
                                        {image.isSelected ? "ยกเลิกการเลือก" : "เลือก"}
                                    </button>
                                    <IconButton
                                            color="error"
                                            className="position-absolute top-0 end-0 m-2"
                                            onClick={() => handleDeleteImage(image._id)}
                                            title="ลบรูปภาพ"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    <div className="mt-2">
                                        <label>ลำดับ (Banner):</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={image.order?.banner || ""}
                                            onChange={(e) => {
                                                const newOrder = parseInt(e.target.value, 10) || 0;
                                                setUploadedImagesBanner((prev) =>
                                                    prev.map((img) =>
                                                        img._id === image._id
                                                            ? { ...img, order: { ...img.order, banner: newOrder } }
                                                            : img
                                                    )
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="text-center mt-4">
                <button
                    className="btn btn-success"
                    onClick={handleSaveSelectedBannerImages}
                    disabled={uploadedImagesBanner.length === 0}
                >
                    บันทึกรายการ banner ที่เลือก
                </button>
            </div>

            <div className="mt-5">
                <h3>Preview Banner</h3>
                {selectedImagesBanner.length > 0 ? (
                    <div className="row">
                        {[...selectedImagesBanner]
                        .sort((a, b) => (a.order?.banner || 0) - (b.order?.banner || 0))
                        .map((image) => (
                            <div className="col-md-12 mb-3" key={image._id}>
                                <img src={image.url} alt={image.alt} className="img-fluid" />
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>ยังไม่มี banner ที่เลือก</p>
                )}
            </div>
        </>
    )
}

export default ImageRow
